import { createSlice } from "@reduxjs/toolkit";
import {
  POSTCODE_DISTRICT_BOUNDARIES_ID,
  POSTCODE_SECTOR_BOUNDARIES_ID,
  POSTCODE_UNIT_BOUNDARIES_ID,
  POSTCODE_LEVEL_MATRIX_ID,
} from "../../consts/sources";

const initialState = {
  postcodeDistrictBoundaries: false,
  postcodeSectorBoundaries: false,
  postcodeUnitBoundaries: false,
  postcodeLevelMatrix: false,
};

export const sourcesSlice = createSlice({
  name: "sources",
  initialState,
  reducers: {
    setSourceLoaded: (state, action) => {
      state[action.payload] = true;
    },
    resetSources: (state) => {
      state[POSTCODE_DISTRICT_BOUNDARIES_ID] = false;
      state[POSTCODE_SECTOR_BOUNDARIES_ID] = false;
      state[POSTCODE_UNIT_BOUNDARIES_ID] = false;
      state[POSTCODE_LEVEL_MATRIX_ID] = false;
    },
  },
});

const { reducer, actions } = sourcesSlice;
const { setSourceLoaded, resetSources } = actions;

export { reducer, setSourceLoaded, resetSources };
